import React, { useState } from "react";

import classnames from "classnames";

import { Collapse } from "Cobalt/Collapse";
import { Table as TableWithStyleProps } from "Common/HTML";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("CobaltTable");
export const Table = ({ ...props }) => <TableWithStyleProps {...props} className={bem()} />;
export const TR = ({ subRow, expanded, headless, children, onClick, className, ...rest }) => {
  const classes = classnames(bem("Row"), className, {
    [bem(null, "subRow")]: subRow,
    [bem(null, "expandedRow")]: expanded,
    [bem(null, "headless")]: headless,
  });
  return (
    <tr onClick={onClick} className={classes} {...rest}>
      {children}
    </tr>
  );
};
export const THead = ({ children }) => (
  <thead>
    <TR>
      {children}
      {/* automatically insert empty header cell on mobile to hold space for caret */}
      <TH className="sm:hidden" />
    </TR>
  </thead>
);
export const TH = ({ children, className, ...rest }) => {
  const classes = classnames(bem("HeaderCell"), className);
  return (
    <th className={classes} {...rest}>
      {children}
    </th>
  );
};
export const TD = ({ children, className, ...rest }) => {
  const classes = classnames(bem("Cell"), className);
  return (
    <td className={classes} {...rest}>
      {children}
    </td>
  );
};
export const TDFoot = ({ children, className, ...rest }) => {
  const classes = classnames(bem("FooterCell"), className);
  return (
    <td className={classes} {...rest}>
      {children}
    </td>
  );
};
export const ExpandingRow = ({ mainContent, expandingContent, colspan = "3" }) => {
  const [isOpen, setOpenState] = useState(false);
  return (
    <>
      <TR expanded={!!isOpen}>
        {mainContent}
        <TD>
          <Icon pl={2} pr={2} icon={isOpen ? "angle-up" : "angle-down"} onClick={() => setOpenState(!isOpen)} />
        </TD>
      </TR>
      <Collapse in={isOpen} mountOnEnter>
        <TR>
          <TD className={bem("ExpandedSection")} colSpan={colspan}>
            <Table>
              <tbody>{expandingContent}</tbody>
            </Table>
          </TD>
        </TR>
      </Collapse>
    </>
  );
};
